export default "18d972b70f2189e9.png"